<p-dialog
  [header]="header"
  [styleClass]="'lib-confirm-dialog ' + styleClass"
  [(visible)]="visible"
  (onHide)="onClose($event)"
  (onShow)="showDialog.emit($event)"
  [minY]="70"
  [modal]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  [resizable]="false"
  [style]="{ width: width }"
>
  <ng-content></ng-content>
  <p-footer>
    <div class="lib-confirm-dialog__footer">
      <div #customFooter><ng-content select="[footer]"></ng-content></div>
      <div #customFooterElements><ng-content select="[customFooterElements]"></ng-content></div>
      <button
        *ngIf="
          !customFooter.children.length && !customFooterElements.children.length && hasAcceptButton
        "
        type="button"
        id="DialogBtnOk"
        class="dialog_Btn"
        (click)="onAccept()"
      >
        {{ acceptButtonLabel }}
      </button>
      <button
        *ngIf="!customFooter.children.length && !customFooterElements.children.length"
        type="button"
        id="DialogBtnCancel"
        class="dialog_Btn"
        (click)="onClose(true)"
      >
        {{ closeButtonLabel }}
      </button>
    </div>
  </p-footer>
</p-dialog>
